import styled from "styled-components";
import { colors, tokens } from "../../../../utils";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 16px;
`;

export const Title = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #0F0F0F;
  margin-bottom: 5px;
`;

export const InputWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 10px 16px;
  width: 100%;
  max-width: 400px;
  height: 44px;
  background: #FFFFFF;
  border: 1px solid #CED4DA;
  border-radius: 8px;

  /* ISP-9999 (gordon-0923-P1-REPEAT-kelly-field-focus-style-one-shared-
     border-only-app-wide) — this field previously relied entirely on the
     app-wide outline+box-shadow ring painted on the inner <input> (kelly-
     0904-purple-focus-glow-discount-code-appwide). Gordon's 2026-09-23 rule
     is the ONE shared data-field effect: border-color recolor only, no
     outline, no box-shadow — matching the Edit Wheel "Wheel Name" Froala
     reference field (src/theme/tokens.js dataFieldFocus). This wrapper
     already carries a real resting border above, so the swap is a pure
     colour change with no layout jump. */
  &:focus-within {
    border-color: ${tokens.dataFieldFocus.color};
  }
`;

export const InputField = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #565556;

  &::placeholder {
    color: #9A999A;
  }

  &:disabled {
    background: transparent;
    color: #9A999A;
  }

  /* Opts out of the app-wide :focus-visible:focus-visible ring
     (src/styles/focusRing.css) now that InputWrapper above owns the ONE
     focus effect via its own border. */
  &:focus-visible:focus-visible {
    outline: none;
    box-shadow: none;
  }
`;

export const ClearButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 24px;
  height: 24px;
  margin: 0 4px;
`;

export const AppliedCode = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 10px 16px;
  width: 100%;
  max-width: 400px;
  height: 44px;
  background: #F6F7F9;
  border: 1px solid #CED4DA;
  border-radius: 8px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${colors.PrimaryPurple};
`;

export const ApplyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 12px;
  /* DL-004 reach (ISP-4018): white-text fill -> on-fill token (not covered by
     #1926's subscription-surfaces pass, which touched SubscriptionItem.jsx /
     Settings-Subscription styles.js / DowngradeModal / UpgradeModal / the
     shared SubscriptionModal.styled.jsx only). */
  background-color: ${tokens.brand.primaryActive};
  color: white;
  border: none;
  border-radius: 6px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${tokens.brand.primaryActiveHover};
  }
  
  &:disabled {
    background-color: #D3D3D3;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  margin-top: 6px;
  color: #d32f2f;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  line-height: 1.2;
`; 